module.exports = __webpack_public_path__ + "img/location-category-online.30cfde3.webp";